import React, { useState, useRef } from "react";
import "./Rightpart.css";
// import "./OrderRight";
import profile from "../assets/images/profile.png";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function ProfileRight() {
  const [profileImg, setProfileImg] = useState(profile);
  const fileInputRef = useRef(null);

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImg(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="dashbord-header">
          <p className="title-dash">Profile</p>

          <div className="dropdown-section d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={profile} alt="" />
                  <div className="name-mail">
                    <h4>DEEPAK SHARMA</h4>
                    <p>Deepak@gmail.com</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li>
                  <a className="dropdown-item" href="#">
                    Profile
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Support
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="content-dashborad-outer">
          <div className="row">
            <div className="col-lg-4">
              <div className="profile-pg">
                <div className="profile-container">
                  <div className="profile-photo-pg">
                    <img src={profileImg} alt="Profile" />
                    <div
                      className="edit-icon-overlay"
                      onClick={handleEditClick}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                      </svg>
                    </div>
                  </div>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                </div>
                <h4>Deepak Sharma</h4>
                <div className="detail-cst">
                  <div className="icon-info">
                    <EmailOutlinedIcon />
                    <p>Deepak@gmail.com</p>
                  </div>
                  <div className="icon-info">
                    <LocalPhoneOutlinedIcon />
                    <p> +91 9874563218</p>
                  </div>
                  <div className="icon-info">
                    <FmdGoodOutlinedIcon />
                    <p>
                      15 Corner, Sector 10 Shopping Center Vijay Path Crossing,
                      Madhyam Marg, Mansarovar, Jaipur, Rajasthan 302020
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="profile-detail">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="billing-add-box">
                      <div className="box-top">
                        <div className="sr-number">
                          <h4>Profile</h4>
                        </div>
                      </div>
                      <div className="billing-text profile-form">
                        <div className="row">
                          <div className="col-md-6">
                            <input
                              type="text"
                              placeholder="Deepak"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="text"
                              placeholder="Sharma"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-12">
                            <input
                              type="email"
                              placeholder="Deepak@gmail.com"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-12">
                            <input
                              type="text"
                              placeholder="+91 9874563218"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-12">
                            <textarea
                              placeholder="15 Corner, Sector 10 Shopping Center Vijay Path Crossing, Madhyam Marg, Mansarovar, Jaipur, Rajasthan 302020"
                              className="form-control"
                            ></textarea>
                          </div>
                          <div className="col-md-12">
                            <button className="save-btn">Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="billing-add-box password-sect">
                      <div className="box-top">
                        <div className="sr-number">
                          <h4>Change Password</h4>
                        </div>
                      </div>
                      <div className="billing-text password-change">
                        <div className="input-box">
                          <input
                            type="password"
                            placeholder="Current Password"
                          />
                        </div>

                        <div className="input-box">
                          <input
                            type="password"
                            placeholder="Confirm Password"
                          />
                        </div>

                        <button className="change-btn">Change Password</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
